import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import { useElementContext, useProductType } from "@ten24/slatwall-storefront-react-private/global";
import { useContentContext } from "../../contexts/ContentContext";

import DynamicPage from "../DynamicPage/DynamicPage";
import { ProductTypeList } from "../../components/ProductTypeList/ProductTypeList";
import { PageContentRow } from "../../components/PageContentRow/PageContentRow";

const ProductType = () => {
  const { SearchListingStack, ListingBanner } = useElementContext();
  const { id } = useParams();

  const { productTypeRequest, productTypeData, productTypeListRequest, isError, errorMessage } = useProductType();
  const pageData = useContentContext();

  const { productTypeSearchListing, productListingSettings, rangeTilesSettings } = pageData.templateData || {};
  if (!productTypeSearchListing) return <DynamicPage />;

  const { setting: { productHTMLTitleString } = {} } = productTypeRequest.data || {};

  const title = pageData?.title || productTypeData?.productTypeName;
  const pageLogo = pageData?.pageLogo || productTypeData?.imageFile;
  const description = pageData?.description || productTypeData?.productTypeDescription;

  return (
    <DynamicPage>
      {({ renderDynamicContent }) => (
        <>
          {productHTMLTitleString && <Helmet title={productHTMLTitleString} />}
          <PageContentRow>
            <ListingBanner heading={title} images={[pageLogo]} description={description} type="productType" />
          </PageContentRow>

          {isError && (
            <div className="container bg-light box-shadow-lg rounded-lg p-5">
              <div className="row">
                <div className="alert alert-info" role="alert">
                  {errorMessage}
                </div>
              </div>
            </div>
          )}

          {renderDynamicContent()}

          {rangeTilesSettings !== "hideRangeTiles" && (
            <ProductTypeList
              showOnlyDirectChild={rangeTilesSettings === "showOnlyDirectChild"}
              isFetching={productTypeListRequest.isFetching || !productTypeRequest.isLoaded}
              data={productTypeData}
            />
          )}

          {productListingSettings !== "hideProductListing" && (
            <SearchListingStack
              hide="productType"
              initPreFilter={{
                productType_slug: id,
              }}
              {...productTypeSearchListing}
            />
          )}
        </>
      )}
    </DynamicPage>
  );
};

export default ProductType;
